import EntityModel from '@/common/models/entity-model';

export default class WebsiteModel extends EntityModel {
    hydrate({
        id = null,
        name = null,
        serviceEmail = null,
        servicePhone = null,
        url = 'https://',
        customFields = null,
        organizationId,
        inUse = false,
    } = {}) {
        this.id = id;
        this.name = name;
        this.serviceEmail = serviceEmail;
        this.servicePhone = servicePhone;
        this.url = url;
        this.customFields = customFields;
        this.organizationId = organizationId;
        this.inUse = inUse;
    }

    get hasCustomFields() {
        return Object.keys(this.customFields || {}).length > 0;
    }

    getPayload() {
        return {
            id: this.id,
            name: this.name,
            serviceEmail: this.serviceEmail,
            servicePhone: this.servicePhone,
            url: this.url,
            customFields: this.customFields,
            organizationId: this.organizationId,
        };
    }
}
